import PropTypes from 'prop-types';
import { useMemo } from 'react';
// @mui
import { CssBaseline } from '@mui/material';
import {
    ThemeProvider as MUIThemeProvider,
    createTheme,
    StyledEngineProvider
} from '@mui/material/styles';
//
import palette from './palette';
import shadows from './shadows';
import typography from './typography';
import GlobalStyles from './globalStyles';
import customShadows from './customShadows';
import componentsOverride from './overrides';
import config from '../config';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
    children: PropTypes.node
};

export default function ThemeProvider({ children }) {
    const rootElement = document.getElementById("root");

    const themeOptions = useMemo(
        () => ({
            palette: { ...palette, ...config.palette },
            shape: { borderRadius: 6 },
            typography,
            shadows: shadows(),
            customShadows: customShadows()
        }),
        []
    );

    const theme = createTheme(themeOptions);
    theme.components = {
        ...componentsOverride(theme),
        MuiPopover: {
            defaultProps: {
                container: rootElement
            }
        },
        MuiPopper: {
            defaultProps: {
                container: rootElement
            }
        },
        MuiDialog: {
            defaultProps: {
                container: rootElement,
            }
        },
        MuiModal: {
            defaultProps: {
                container: rootElement
            }
        }
    };
    return (
        <StyledEngineProvider injectFirst>
            <MUIThemeProvider theme={theme}>
                <CssBaseline />
                <GlobalStyles />
                {children}
            </MUIThemeProvider>
        </StyledEngineProvider>
    );
}
